import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4001';

function CheckoutProductionModal({ screen, currentUser, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    orderNumber: '',
    expectedImpressions: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.orderNumber || !formData.expectedImpressions) {
      setError('All fields are required');
      return;
    }

    if (parseInt(formData.expectedImpressions) <= 0) {
      setError('Expected impressions must be greater than 0');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/silkscreens/${screen.id}/checkout-production`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          orderNumber: formData.orderNumber,
          expectedImpressions: parseInt(formData.expectedImpressions),
          checkedOutBy: currentUser?.id || 'system'
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to checkout screen');
      }

      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '500px',
        width: '100%',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
      }}>
        <h2 style={{
          fontSize: '1.75rem',
          fontWeight: '700',
          color: '#00BCD4',
          marginBottom: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          📤 Checkout for Production
        </h2>

        <div style={{
          background: '#e0f7fa',
          padding: '12px',
          borderRadius: '8px',
          marginBottom: '24px',
          fontSize: '0.9rem',
          color: '#00838f'
        }}>
          <strong>{screen.screenCode}</strong> - {screen.currentCustomerName}
          <br />
          {screen.currentItemDescription}
        </div>

        {error && (
          <div style={{
            background: '#ffebee',
            color: '#c62828',
            padding: '12px',
            borderRadius: '8px',
            marginBottom: '16px',
            fontSize: '0.9rem'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#333',
              fontSize: '0.95rem'
            }}>
              Work Ticket Number *
            </label>
            <input
              type="number"
              name="orderNumber"
              value={formData.orderNumber}
              onChange={handleChange}
              placeholder="e.g., 3456 (WT will be added automatically)"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #e0e0e0',
                borderRadius: '8px',
                fontSize: '1rem',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#00BCD4'}
              onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
              required
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: '600',
              color: '#333',
              fontSize: '0.95rem'
            }}>
              Expected Impressions *
            </label>
            <input
              type="number"
              name="expectedImpressions"
              value={formData.expectedImpressions}
              onChange={handleChange}
              placeholder="e.g., 5000"
              min="1"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #e0e0e0',
                borderRadius: '8px',
                fontSize: '1rem',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#00BCD4'}
              onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
            />
          </div>

          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-end'
          }}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                padding: '12px 24px',
                background: '#f5f5f5',
                color: '#666',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => !loading && (e.target.style.background = '#e0e0e0')}
              onMouseLeave={(e) => e.target.style.background = '#f5f5f5'}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '12px 24px',
                background: loading ? '#b0bec5' : '#00BCD4',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => !loading && (e.target.style.background = '#00ACC1')}
              onMouseLeave={(e) => !loading && (e.target.style.background = '#00BCD4')}
            >
              {loading ? 'Checking Out...' : 'Checkout for Production'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CheckoutProductionModal;
